import './WithdrawButtonStyle.scss';
import { Button, ButtonSize, FillType } from 'views/components/atoms/button';
import { EstablishError } from 'views/components/atoms/establishes/error';
import { EstablishText } from 'views/components/atoms/establishes/text';
import { formatNumberForInt } from 'views/utils/format/FormatNumber';
import { toHankaku } from 'views/utils/format/FormatString';

type WithdrawButtonProps = {
  withdrawAmount: string;
  setWithdrawAmount: React.Dispatch<React.SetStateAction<string>>;
  isError: boolean;
  errorText?: string;
  onBlur: () => void;
  onClick: () => void;
  disabled?: boolean;
};

const formatWithdrawAmountInput = (value: string) => {
  const hankakuValue = toHankaku(value.trim());
  const normalizedValue = hankakuValue.replace(/,/g, '');
  if (normalizedValue === '') return '';
  if (!/^\d+$/.test(normalizedValue)) {
    return hankakuValue;
  }

  return formatNumberForInt(Number(normalizedValue));
};

export const WithdrawButton = (props: WithdrawButtonProps) => {
  const { withdrawAmount, setWithdrawAmount, isError, errorText, onBlur, onClick, disabled } = props;
  return (
    <div className="withdrawButton">
      <div className="withdrawButton_input">
        <div className="withdrawButton_amount">
          <EstablishText
            inputType="text"
            inputValue={withdrawAmount}
            setInputValue={(e) => setWithdrawAmount(e.target.value)}
            onBlur={() => {
              setWithdrawAmount((currentWithdrawAmount) => formatWithdrawAmountInput(currentWithdrawAmount));
              onBlur();
            }}
          />
          <div className="withdrawButton_amount_yen">円</div>
        </div>
        <div className="withdrawButton_error">
          <EstablishError isEnabled={isError} errorText={errorText} />
        </div>
      </div>
      <div className="withdrawButton_button">
        <Button
          label="出金予約"
          fillType={FillType.primaryFill}
          buttonSize={ButtonSize.sizeS}
          disabled={disabled}
          onClick={() => {
            console.log('出金', withdrawAmount);
            onClick();
          }}
        />
      </div>
    </div>
  );
};
